import { InputPadrao } from '../../../../components/Inputs'
import { InputSimNao, InputTipoTabelaProcedimento } from '../../../../components/InputsAutoComplete'
import React, { useState, useEffect } from 'react'
import Yup from '../../../../util/Validacoes'
import { HeaderCadastro } from '../../../../components/Headers'
import { mostrarToast } from '../../../../components/Toasts'
import { Formik, Form } from 'formik'
import { BotaoPadrao } from '../../../../components/Botoes'
import { mensagens } from '../../../../util/Utilitarios'
import { useParams } from 'react-router-dom'
import { Link } from 'react-router-dom'
import { salvar, get } from '../../../../util/AcessoApi'
import '../../../../assets/css/icones/iconsmind/style.css';
import Atalho from '../../../../util/Atalho'

const CadastroTabelaProcedimento = props => {
    let { id } = useParams()

    const [salvarENovo, setSalvarENovo] = useState(false)
    const [salvando, setSalvando] = useState(false)
    const [valoresIniciais, setValoresIniciais] = useState({})
    const [validacao] = useState(Yup.object({
        tipo: Yup.string().required().nullable(),
        descricao: Yup.string().required().nullable().max(200).trim(),
        codigo_tiss: Yup.string().required().nullable().max(50).trim(),
        utiliza_agendamento: Yup.string().nullable(),
    }))

    const manter = ['tipo', 'codigo_tiss', 'utiliza_agendamento']

    const Submit = (values, propsFormik) => {
        setSalvando(true)

        salvar(
            { ...values },
            '/faturamento/tabelaProcedimento',
            obj => {
                if (props.modal) {
                    if (salvarENovo) {
                        propsFormik.resetForm({})
                        manter.forEach(x => propsFormik.setFieldValue(x, values[x]))
                        setSalvando(false)
                        setSalvarENovo(false)
                    }
                    else {
                        props.setItemSelecionado({ value: obj.id, label: obj.descricao })
                        props.setShow && props.setShow(false)
                    }
                }
                else {
                    mostrarToast('sucesso', mensagens.sucesso)
                    if (salvarENovo) {
                        propsFormik.resetForm({})
                        manter.forEach(x => propsFormik.setFieldValue(x, values[x]))
                        setSalvando(false)
                    }
                    else
                        props.history.push('/faturamento/tabelaProcedimento/consulta')
                }
            },
            () => setSalvando(false))
    }

    useEffect(_ => {
        if (!props.modal)
            Promise.resolve(get(`/faturamento/tabelaProcedimento/${id}`)).then(obj => {
                if (id && !obj.id)
                    props.history.push('/faturamento/tabelaProcedimento/consulta')

                setValoresIniciais(obj)
            })
    }, [id])

    const links = [
        () => <Link to={'/dashboard'}>Dashboard</Link>,
        () => <span>faturamento</span>,
        () => <Link className='link-active' to={'/faturamento/tabelaProcedimento/consulta'}>Tabela Procedimento</Link>,
    ]

    return (
        <Formik
            initialValues={valoresIniciais}
            validationSchema={validacao}
            enableReinitialize={true}
            onSubmit={(values, propsFormik) => Submit(values, propsFormik)}>
            {propsFormik => {
                return (<Form>
                    {!props.modal && <HeaderCadastro titulo={"Cadastro Tabela Procedimento"} link={links} />}
                    <div className={props.modal && props.modal || 'card mb-20'}>
                        <div className={props.modal || 'card-body'}>
                            <div className='row'>
                                <InputPadrao label='Id' name='id' type='hidden' placeholder='Id' />
                                <InputTipoTabelaProcedimento label='Tipo' name="tipo" placeholder="Tipo" propsFormik={propsFormik} obrigatorio={true}
                                    tamanho={!props.modal && 'col-lg-3'} classeTooltip={props.modal && 'tooltip-input-modal'} autoFocus salvarENovo={salvarENovo} />
                                <InputPadrao label='Descrição' name='descricao' type='text' placeholder='Descrição' obrigatorio={true}
                                    tamanho={!props.modal && 'col-lg-3'} classeTooltip={props.modal && 'tooltip-input-modal'} />
                                <InputPadrao label='Código TISS' name='codigo_tiss' type='text' placeholder='Código TISS' obrigatorio={true}
                                    tamanho={!props.modal && 'col-lg-3'} classeTooltip={props.modal && 'tooltip-input-modal'} />
                                <InputSimNao label="Utiliza Agendamento?" name="utiliza_agendamento" type="select" placeholder="Utiliza Agendamento?"
                                    tamanho={!props.modal && 'col-lg-3'} isClearable={true} noOptionsMessage={_ => ""} propsFormik={propsFormik}
                                    classeTooltip={props.modal && 'tooltip-input-modal'} />
                                <Atalho formik={propsFormik} salvando={salvando} setSalvareNovo={setSalvarENovo}  salvarENovo={true} />

                            </div>
                        </div>
                    </div>
                    {!props.modal && <div className='separator mt-40 mb-5'></div>}
                    <div className='direita container-botoes mb-3 group-salvar-novo'>
                        <BotaoPadrao texto='Salvar' disabled={salvando} click={_ => setSalvarENovo(false)} idTooltip={'salvar'}/>
                        {(props.modal || !id) && <BotaoPadrao texto='Salvar e Novo' disabled={salvando} click={_ => setSalvarENovo(true)}  idTooltip={'salvarENovo'}/>}
                    </div>
                </Form>)
            }}
        </Formik>
    )
}

export default CadastroTabelaProcedimento